import axios from 'axios';

import { JsonResponse } from 'core/models/response';
import { CompanyOverviewResponse } from '../models/overview';

export const onGetCompanyOverview = async () => {
	try {
		const response = await axios.get<JsonResponse<CompanyOverviewResponse>>('dashboard/company-overview');
		return response.data.data;
	} catch (error) {
		throw error;
	}
};
